module.exports = __webpack_public_path__ + "static/media/title_2.15051fab.svg";